import i18next from 'i18next';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';
import { RoutesString } from '../../Modules/routesString';
import './header.scss';

const Header: React.FC = () => {
  const [showMenu, setshowMenu] = useState(false);
  const { t } = useTranslation();
  const activeLang = localStorage.getItem('i18nextLng');

  const handleShowMenu = () => {
    setshowMenu(!showMenu);
  };

  return (
    <div className="header">
      <div className="header_box">
        {/* icons bars menu */}
        <div
          className={
            showMenu
              ? 'header_box_menu_mobile-tonggle active'
              : 'header_box_menu_mobile-tonggle'
          }
          onClick={handleShowMenu}
        >
          <span></span>
          <span></span>
        </div>

        <div className="header_box_lang">
          <div
            className={
              activeLang == 'kr' || !activeLang ? 'lang active' : 'lang'
            }
          >
            <span onClick={() => i18next.changeLanguage('kr')}>KR</span>
          </div>
          <div className={activeLang == 'en' ? 'lang active' : 'lang'}>
            <span onClick={() => i18next.changeLanguage('en')}>EN</span>
          </div>
        </div>

        {/* menu */}
        <div
          className={showMenu ? 'header_box_menu active' : 'header_box_menu'}
        >
          <div className="header_box_menu_mobile-icon-close">
            <div className="header_box_lang">
              <div
                className={
                  activeLang == 'kr' || !activeLang ? 'lang active' : 'lang'
                }
              >
                <span onClick={() => i18next.changeLanguage('kr')}>KR</span>
              </div>
              <div className={activeLang == 'en' ? 'lang active' : 'lang'}>
                <span onClick={() => i18next.changeLanguage('en')}>EN</span>
              </div>
            </div>
          </div>

          <div className="menu">
            <NavLink exact to={RoutesString.Home} onClick={handleShowMenu}>
              Home
            </NavLink>
            <NavLink to={RoutesString.Works} onClick={handleShowMenu}>
              Works
            </NavLink>
            <NavLink to={RoutesString.Contacts} onClick={handleShowMenu}>
              Contact
            </NavLink>
          </div>

          <div className="infoWrapper">
            <p id="adress">
              {t('adress')}
              <br />
              T 070-4272-8645
            </p>
            <p className="link">
              <a
                href="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3163.2672191083275!2d127.04388909999999!3d37.54876759999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x357ca49ee880a2b9%3A0x3184b6c03fe0f43!2z64yA7ZWc66-86rWtIOyEnOyauO2KueuzhOyLnCDshLHrj5nqtawg7JmV7Iut66as66GcIDEyNSA07Li1IDQxMQ!5e0!3m2!1sko!2s!4v1706190148368!5m2!1sko!2s"
                target="_blank"
              >
                View Map
              </a>
              
            </p>
            <br />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
